import { StaffLevelRights } from '@/types/Staff.ts'
import { DEFAULT_PERMISSIONS, Permissions, RightsRW, StaffPermissions, StaffRights } from '@/types/StaffRights.ts'

export function mapRightsToPermissions(rights: StaffLevelRights | null): StaffPermissions {
    if (!rights) return DEFAULT_PERMISSIONS

    return {
        daycareSettings: { read: rights.rw_params_daycare > 0, write: rights.rw_params_daycare > 1 },
        staffList: { read: rights.rw_staffs > 0, write: rights.rw_staffs > 1 },
        staffCalendar: { read: rights.rw_staff_work > 0, write: rights.rw_staff_work > 1 },
        parentList: {
            read: rights.rw_families > 0 && rights.rw_child > 0,
            write: rights.rw_families > 1 && rights.rw_child > 1
        },
        occasionalSlots: {
            read: rights.rw_occasional_slot > 0 && rights.rw_request_slot > 0,
            write: rights.rw_occasional_slot > 1 && rights.rw_request_slot > 1
        },
        regularSlots: { read: rights.rw_regular_slot > 0, write: rights.rw_regular_slot > 1 },
        news: {
            read: rights.rw_news > 0 && rights.rw_event_days > 0 && rights.rw_closing_days > 0,
            write: rights.rw_news > 1 && rights.rw_event_days > 1 && rights.rw_closing_days > 1
        },
        addNewsWithoutValidation: { write: rights.w_add_posts },
        suggestions: { read: rights.rw_suggestions > 0, write: rights.rw_suggestions > 1 },
        taskNote: { read: rights.rw_task_note > 0, write: rights.rw_task_note > 1 },
        meal: { read: rights.rw_meal > 0, write: rights.rw_meal > 1 }
    }
}

export function mapPermissionsToGraphQLVars(permissions: StaffPermissions): StaffRights {
    const toRW: (perm: Permissions) => RightsRW = (perm: Permissions): RightsRW => (perm.write ? 2 : perm.read ? 1 : 0)

    return {
        rw_params_daycare: toRW(permissions.daycareSettings),
        rw_staffs: toRW(permissions.staffList),
        rw_staff_work: toRW(permissions.staffCalendar),

        rw_families: toRW(permissions.parentList),
        rw_child: toRW(permissions.parentList),
        rw_occasional_slot: toRW(permissions.occasionalSlots),
        rw_request_slot: toRW(permissions.occasionalSlots),
        rw_regular_slot: toRW(permissions.regularSlots),

        rw_news: toRW(permissions.news),
        rw_event_days: toRW(permissions.news),
        rw_closing_days: toRW(permissions.news),
        w_add_posts: permissions.addNewsWithoutValidation.write,

        rw_suggestions: toRW(permissions.suggestions),
        rw_task_note: toRW(permissions.taskNote),
        rw_meal: toRW(permissions.meal)
    }
}

export function hasPermissionsChanged(current: StaffPermissions, original: StaffPermissions): boolean {
    return JSON.stringify(current) !== JSON.stringify(original)
}
